import Rails from "@rails/ujs";
import { Controller } from "@hotwired/stimulus"
import SignaturePad from 'signature_pad/dist/signature_pad.min.js';

export default class extends Controller {
  static targets = [ "name", "categories","result", "waiting", "message", "form" ]

  connect() {
    this.signaturePad = new SignaturePad(document.getElementById('signature-pad'), {
      backgroundColor: 'rgba(255, 255, 255, 0)',
      penColor: 'rgb(0, 0, 0)',
      onEnd: function (event) {
        $('#signature_input').val(this.toDataURL())
      }
    });
  }
}
